import React, { useEffect } from "react";
import Layout from '../components/layout/Layout';

export default function ProjectC() {
  // Scroll to top when component loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <Layout>
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-8xl font-light mb-12">Teaching</h1>
          
          <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
            <h2 className="text-3xl font-light mt-12 mb-6">Teaching Philosophy</h2>
            <p>
              I believe in nurturing each student's unique musical voice while building a strong technical foundation. My approach combines classical training methods with modern pedagogical techniques to help students of all levels reach their full potential. Every student learns differently, and I tailor my teaching style to meet individual needs, goals, and learning preferences.
            </p>
            
            <h2 className="text-3xl font-light mt-12 mb-6">What I Teach</h2>
            <p>
              My curriculum covers comprehensive violin instruction including classical technique, bow control, intonation, vibrato, shifting, and advanced repertoire preparation. I also incorporate music theory, ear training, sight-reading, and performance skills. Students learn to interpret music with depth and emotion while developing the technical precision needed for artistic expression.
            </p>
            
            <h2 className="text-3xl font-light mt-12 mb-6">Student Levels</h2>
            <p>
              I work with students of all ages and skill levels, from beginners picking up the violin for the first time to advanced students preparing for competitions, auditions, and conservatory admissions. Whether you're a young student just starting your musical journey or an adult returning to the violin, I provide personalized instruction that meets you where you are and helps you grow.
            </p>
            
            <h2 className="text-3xl font-light mt-12 mb-6">Lesson Information</h2>
            <p>
              Lessons are available in 30, 45, or 60-minute sessions, offered both in-person and online. I maintain a flexible schedule to accommodate students' busy lives while ensuring consistent progress through regular practice and instruction. Each lesson is structured to balance technical exercises, repertoire study, and musical development.
            </p>
            
            <h2 className="text-3xl font-light mt-12 mb-6">Student Success</h2>
            <p>
              I take pride in my students' achievements, which include competition awards, acceptance into prestigious youth orchestras, successful conservatory auditions, and memorable recital performances. Beyond these accomplishments, my greatest joy comes from watching students develop a lifelong love of music and the confidence to express themselves through their instrument.
            </p>

            <h2 className="text-3xl font-light mt-12 mb-6">Get Started</h2>
            <p>
              Interested in violin lessons? I'd love to hear from you! Contact me to discuss your musical goals, schedule a trial lesson, and find the perfect lesson plan to help you achieve your aspirations. Whether you're just beginning or looking to refine your skills, I'm here to support your musical journey.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}